import styled, { css } from "styled-components";
import { upperMenuHeight } from "../../../common/parameters";

import { IPlayWrapperStyleProps } from "./interfaces";

export const StyledLoader = styled.div`
    margin-top: 100px;
    ${p => p.theme.sm.min(css`margin-top: calc((100vh - 150px) / 2);`)}
`;

export const PlayWrapper = styled.div<IPlayWrapperStyleProps>`
    ${p =>
        !p.isSimulation
            ? css`
                  width: 100vw;
                  height: calc(100vh - ${upperMenuHeight}px);
              `
            : css`
                  height: 100%;
              `}
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: ${upperMenuHeight}px;
`;
